import type { AzureSpeechSettingsPayload } from '@Application/Ai/AiConfiguration/Models/Actions/aiModelsFetched';

/** Microsoft settings of an Azure Speech model. `phraseWeight` `null` means "Microsoft's own weight". */
class AzureSpeechSettingsView {
	readonly locale: string;
	readonly maxSpeakers: number;
	readonly profanityFilter: boolean;
	readonly phrases: readonly string[];
	readonly phraseWeight: number | null;

	constructor(payload: AzureSpeechSettingsPayload) {
		this.locale = payload.locale;
		this.maxSpeakers = payload.maxSpeakers;
		this.profanityFilter = payload.profanityFilter;
		this.phrases = Object.freeze([...payload.phrases]);
		this.phraseWeight = payload.phraseWeight;

		Object.freeze(this);
	}
}

export default AzureSpeechSettingsView;
